export function drawLine(canvases, stroke, type) {
    const canvas = canvases.get(stroke.l);
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    ctx.strokeStyle = stroke.c ? stroke.c : "#000";
    ctx.lineWidth = stroke.s ? stroke.s : 1.0;
    ctx.lineCap = 'round';

    if (type === 1) {
        ctx.globalCompositeOperation = "destination-out";
    } else {
        ctx.globalCompositeOperation = "source-over";
        switch (stroke.b) {
            case 1: ctx.globalCompositeOperation = "destination-over"; break;
            case 2: ctx.globalCompositeOperation = "source-atop"; break;
            case 3: ctx.globalCompositeOperation = "soft-light"; break;
            default: break;
        }
    }

    ctx.beginPath();
    ctx.moveTo(stroke.x, stroke.y);
    ctx.lineTo(stroke.x2, stroke.y2);
    ctx.stroke();
}
